define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    url: function(){
      if (this.tokenType && this.tokenType == 'refresh') {
        return '/delegate/civics-api/auth/jwt'
      } else {
        return'/delegate/civics-api/api/portal/token/auth';
      }
    },
    sync: function(method, model, options) {
      var token = model.get('token');

      if (options === undefined || options === null) {
        options = {};
      }

      if (token != null){
        options.beforeSend = (xhr) => {
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.setRequestHeader('X-ips-maintain-session', 'true');
        };
      }

      return Backbone.sync(method, model, options);
    }
  });
});
